import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const ddGitlabFrontendPlugin = createPlugin({
  id: 'dd-gitlab-frontend',
  routes: {
    root: rootRouteRef,
  },
});

export const DdGitlabFrontendPage = ddGitlabFrontendPlugin.provide(
  createRoutableExtension({
    name: 'DdGitlabFrontendPage',
    component: () =>
      import('./components/ExampleComponent').then(m => m.ExampleComponent),
    mountPoint: rootRouteRef,
  }),
);
